<template>
  <v-container class="pb-0" fluid>
    <v-row class="b-b align-center pt-3 pt-sm-0 navbar">
      <!-- Logo -->
      <v-col cols="12" sm="2" class="pl-4 order-xs1 logo-container">
        <div class="logo" @click="$router.push('/')">
          <div class="logo-jobsin">JOBS IN</div>
          <div class="logo-region">{{ this.region }}</div>
          <div v-if="admin" class="logo-admin-badge">ADMIN</div>
          <div v-else class="beta-badge">Beta</div>
        </div>
        <JobCart v-if="$vuetify.breakpoint.xsOnly"></JobCart>
      </v-col>
      <!-- Keyword filter -->
      <v-col cols="12" sm="3" md="3" class="order-xs3 pb-2 pt-2" v-if="!contentPage && !admin">
              <v-combobox
                label="Seach for..."
                v-model="keywords"
                class="main-search"
                prepend-icon="mdi-magnify"
                clearable
                dense
                clear-icon="mdi-close-circle"
                outlined
                autocomplete="off"
                single-line
                :items="categories"
                item-text="name"
                item-value="keywords"
                type="search"
                hide-details
                >
              </v-combobox>
      </v-col>
      <!-- Area filter -->
      <v-col cols="12" sm="3" md="3" class="order-xs4 pb-2 pt-2" v-if="!contentPage && !admin">
        <v-menu :max-width="500" :offset-y="true">
          <template v-slot:activator="{ on }">
              <v-text-field
                @click="on.click"
                label="In area.."
                v-model="area"
                class="main-search"
                prepend-icon="mdi-home-city-outline"
                clearable
                dense
                clear-icon="mdi-close-circle"
                autocomplete="off"
                outlined
                single-line
                type="search"
                hide-details
              ></v-text-field>
          </template>
          <v-card elevation="18">
            <v-container fluid>
              <v-row class="pb-2 align-center justify-center b-b ma-0">
                <h4>JOB DISTRIBUTION MAP</h4>
              </v-row>
              <v-row class="ma-2 ml-4">
                <StaticFinlandMap v-if="getSearchResults && getSearchTerms"
                  :searchTerms="getSearchTerms"
                  :graph="getSearchResults"
                  @regionUpdated="area = $event"
                />
              </v-row>
            </v-container>
          </v-card>
        </v-menu>
      </v-col>
      <!-- Job cart -->
      <v-col
        cols="6"
        sm="auto"
        class="justify-end d-none d-sm-block order-xs2 mr-auto"
        v-if="!$vuetify.breakpoint.xsOnly && !admin"
      >
        <JobCart></JobCart>
      </v-col>
      <!-- Work in Finland button -->
      <v-col cols="6" sm="auto" class="justify-end d-none d-lg-block order-xs2 ml-auto"
        style="padding-right: calc(86px + 2em)"
        v-if="!admin">
        <v-btn
          elevation="0"
          color="#FADDD0"
          class="primary--text"
          href="https://workinfinland.com"
          target="_blank"
          small
          :large="$vuetify.breakpoint.width > 1400"
        >
          Get to know Finland
          <v-icon
            right
            class="mr-1"
          >
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </v-col>
      <NavigationDrawer />
    </v-row>
    <v-row v-if="categories !== null &&
      !admin && showCampaign == false &&
      !contentPage" class="d-none d-sm-flex mb-0 pb-2 pt-2 pl-3">
      <v-container fluid v-if="!admin">
        <v-row v-if="minimizeCategories">
          <div>
            <v-btn @click="minimizeCategories = !minimizeCategories" icon color="primary">
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
          </div>
          <v-col class="pt-0 pb-0">
            <span v-if="minimizeCategories">
              <v-chip
                v-for="item in this.categories.slice(
                  0,
                  showAllCategories ? this.categories.length : 6
                )"
                v-bind:key="item.keywords"
                @click="changeKeywords(item.keywords)"
                class="ma-1"
                >{{ item.name }}</v-chip
              >
            </span>
            <v-chip
              color="secondary mr-2"
              @click="showAllCategories = !showAllCategories"
              v-if="minimizeCategories"
              >{{ showAllCategories ? "Show less" : "Show more" }}</v-chip
            >
          </v-col>
        </v-row>
        <v-row v-if="!minimizeCategories" class="align-center" dense>
          <div>
            <v-btn @click="minimizeCategories = !minimizeCategories" icon color="primary">
              <v-icon>mdi-view-column</v-icon>
            </v-btn>
          </div>
          <v-col
            v-for="item in this.categories.slice(
              0,
              showAllCategories ? this.categories.length : 4
            )"
            :key="item.keywords"
            cols="6"
            md="2"
          >
            <v-card
              @click="changeKeywords(item.keywords)"
              max-width="100%"
              hover
              ripple
              color="primary"
            >
              <v-img
                class="white--text align-end drawer-image"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                :src="item.imageUrl !== null ? item.imageUrl : 'undefined'"
              >
                <v-card-title class="subtitle-2 pa-2">{{
                  item.name
                }}</v-card-title>
              </v-img>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            md="2"
          >
            <v-card
              max-width="100%"
              hover
              ripple
              color="primary"
              @click="showAllCategories = !showAllCategories"
            >
              <v-img
                class="white--text align-center drawer-image"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                :src="undefined"
              >
                <v-card-title class="subtitle-2 align-center justify-center text-uppercase">
                  {{ showAllCategories ? "Show less" : "Show more" }}
                </v-card-title>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
import { debounce } from 'debounce';
import StaticFinlandMap from '@/components/StaticFinlandMap.vue';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import JobCart from '@/components/JobCart.vue';
import { labelToRegion } from '../utils';

export default {
  name: 'PositionSearch',
  props: {
    admin: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    StaticFinlandMap,
    NavigationDrawer,
    JobCart,
  },
  data() {
    return {
      categoryDrawer: false,
      areaDrawer: false,
      showAllCategories: false,
      minimizeCategories: false,
      region: 'Finland',
      searchTerms: {
        keywords: '',
        area: '',
      },
      showCampaign: false,
      popularAreas: [
        {
          area: 'Southwest Finland',
          image:
            'https://jobs.workinfinland.fi/wp-content/uploads/2019/12/Talent_Call_Turku_4-495x400.jpg',
        },
        {
          area: 'Turku',
          image:
            'https://jobs.workinfinland.fi/wp-content/uploads/2019/12/Talent_Call_Turku_4-495x400.jpg',
        },
        {
          area: 'Helsinki',
          image:
            'https://jobs.workinfinland.fi/wp-content/uploads/2019/11/tapio-haaja-I9SWvZ9sO2U-unsplash-495x400.jpg',
        },
        {
          area: 'Espoo',
          image:
            'https://jobs.workinfinland.fi/wp-content/uploads/2019/11/espoo-495x400.jpg',
        },
        {
          area: 'Tampere',
          image:
            'https://jobs.workinfinland.fi/wp-content/uploads/2019/11/jyrki-nieminen-5zLhWqntDQA-unsplash-495x400.jpeg',
        },
        {
          area: 'Jyväskylä',
          image:
            'https://jobs.workinfinland.fi/wp-content/uploads/2019/11/jyvaskyla-495x400.jpg',
        },
      ],
      routeTimeout: null,
    };
  },
  mounted() {
    if (this.$route.query.keyword != null) {
      this.keywords = this.$route.query.keyword;
    }

    if (this.$route.query.areas != null) {
      this.area = this.$route.query.areas;
    }

    if (!this.$store.state.categoriesWithDetails) {
      this.$store
        .dispatch('dispatchCategoriesWithDetails')
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          console.log('categories', this.$store.state.categoriesWithDetails);
          this.loading = false;
        });
    }

    if (this.$route.params.areas !== null && this.$route.params.areas !== undefined) {
      const region = this.$route.params.areas;
      if (region !== null) {
        this.area = region;
      } else {
        this.area = region;
      }
    }

    if (this.$route.params.keyword !== null && this.$route.params.keyword !== undefined) {
      this.keywords = this.$route.params.keyword;
    }

    this.$store.dispatch('fetchFavorites');

    this.checkCampaign();
  },
  watch: {
    $route() {
      this.checkCampaign();
      if (this.$route.name === 'index') {
        this.checkIfRegion(this.$route.params.areas);
      }
    },
  },
  methods: {
    checkIfRegion(area) {
      const region = labelToRegion(area);
      if (region !== null) {
        this.region = region.description;
      } else {
        this.region = 'Finland';
      }
    },
    updateSearchTerms: debounce(function _() {
      const terms = this.searchTerms;
      if (terms != null) {
        this.$store.dispatch('commitSearchTerms', terms);
        this.$store.dispatch('commitSearchResults', terms);
      }
    }, 300),
    changeArea(areaString) {
      this.area = areaString;
      this.areaDrawer = false;
    },
    changeKeywords(keywordString) {
      this.keywords = keywordString;
      this.categoryDrawer = false;
      this.showAllCategories = false;
    },
    shouldWeShowKeywords() {
      if (!this.keywords) {
        this.categoryDrawer = !this.admin;
        this.areaDrawer = false;
      } else {
        this.categoryDrawer = false;
        this.areaDrawer = false;
      }
    },
    shouldWeShowAreas() {
      if (!this.area) {
        this.areaDrawer = !this.admin;
        this.categoryDrawer = false;
      } else {
        this.areaDrawer = false;
        this.categoryDrawer = false;
      }
    },
    updateRouteParams($router, newParams) {
      const currentParams = this.$route.name === 'index' || this.$route.name === 'campaign' ? $router.currentRoute.query : $router.currentRoute.params;

      const mergedParams = { ...currentParams, ...newParams };

      Object.keys(mergedParams).forEach((key) => {
        if (mergedParams[key] == null || mergedParams[key] === '') { delete mergedParams[key]; }
      });

      if (mergedParams.keyword) mergedParams.keyword = mergedParams.keyword.toLowerCase();

      const updateRoute = () => {
        this.routeTimeout = null;

        switch (this.$route.name) {
          case 'index':
            this.$router.push({ path: '/', query: mergedParams });
            break;
          case 'filter':
          case 'filter2':
            if (mergedParams.areas && mergedParams.keyword) {
              this.$router.push({ name: 'filter2', params: mergedParams }, () => {});
            } else {
              this.$router.push({ name: 'filter', params: mergedParams }, () => {});
            }
            break;
          case 'campaign':
            this.$router.push({ name: 'campaign', query: mergedParams });
            break;
          default:
        }
      };

      clearTimeout(this.routeTimeout);
      this.routeTimeout = setTimeout(updateRoute, 300);
    },
    openUrl(url) {
      window.open(url);
    },
    removeFavorite(job) {
      this.$store.dispatch('commitFavorite', {
        jobId: job.id,
        action: 'remove',
      });
      return null;
    },
    clearFavorites() {
      this.$store.dispatch('commitFavorite', { action: 'clear' });
    },
    checkCampaign() {
      this.showCampaign = (this.$route.name === 'campaign');
    },
  },
  computed: {
    keywords: {
      get() {
        return this.$store.state.searchTerms.keywords;
      },
      set(value) {
        const keywords = (typeof value === 'object' && value !== null) ? value.keywords : value;
        this.searchTerms.keywords = keywords;
        this.searchTerms.area = this.area;
        this.updateRouteParams(this.$router, { keyword: keywords });
        this.updateSearchTerms();
        this.shouldWeShowKeywords();
      },
    },
    area: {
      get() {
        return this.$store.state.searchTerms.area;
      },
      set(area) {
        this.searchTerms.area = area;
        this.updateRouteParams(this.$router, { areas: area == null ? '' : area.toLowerCase().replace(' ', '-').replace(/ä/g, 'a').replace(/ö/g, 'o') });
        this.updateSearchTerms();
        this.shouldWeShowAreas();
      },
    },
    categories: {
      get() {
        return this.$store.state.categoriesWithDetails
          ? this.$store.state.categoriesWithDetails
          : [];
      },
    },
    getSearchTerms() {
      return this.$store.state.searchTerms;
    },
    getSearchResults() {
      return this.$store.state.searchResults;
    },
    getFavorites() {
      return this.$store.state.userFavorites;
    },
    showCart: {
      get() {
        return this.$store.state.userFavorites.length === 1;
      },
      set(value) {
        return value;
      },
    },
    contentPage() {
      return this.$route.name === 'content';
    },
  },
};
</script>
<style scoped>
.logo {
  text-decoration: none;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.05;
  letter-spacing: -2px;
  color: rgba(0, 45, 160, 1);
  display: flex;
  justify-content: left;
  align-items: center;
  height: 90%;
  flex-wrap: wrap;
  margin-bottom: 1em;
  position: relative;
  cursor: pointer;
}
.logo-region {
  font-weight: 600;
  text-transform: uppercase;
}
.logo-jobsin {
  padding-right: 0.3em;
}
.beta-badge {
  background: rgba(0, 45, 160, 1);
  color: #fff;
  font-size: 0.6rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  padding: 0.22rem 0.22rem 0.22rem 0.3rem;
  border-radius: 0;
  position: fixed;
  left: 0;
  top: 0;
}
.logo-admin-badge {
  background: rgba(0, 45, 160, 1);
  color: #fff;
  font-size: 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  letter-spacing: 0.2rem;
  padding: 0.3rem 0.5rem;
}

.map-button {
  display: inline-block;
}

h4 {
  font-weight: normal;
  color: rgba(0, 45, 160, 1);
}

.search-row {
  padding: 0em 0em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.category-drawer,
.area-drawer {
  z-index: 6;
  background: #fff;
}
.v-card__title {
  word-break: normal !important;
}
.drawer-image {
  height: 60px;
}
.favorites {
  min-width: 400px;
}
.favorites .job:hover {
  background-color: #eeeeee;
}
.subtitle-2{
  font-family: 'finlandica-web' !important;
}
.navbar{
  height: 86px;
}

@media screen and (min-width: 1000px) {
  .logo {
    font-size: 20px;
  }
  .logo-jobsin {
    display: inline;
  }
}

@media screen and (min-width: 1300px) {
  .logo {
    font-size: 28px;
  }
  .drawer-image {
    height: 60px;
  }
}
@media screen and (min-width: 600px) {
  .logo {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 600px) {
  .logo-container{
    height: calc(75px - 11px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);;
    display: flex;
    align-items: center;
    padding-bottom: 22px;
    margin-bottom: 12px;
  }
  .logo{
    margin-bottom: 0;
  }
  .order-xs1{
    order: 1;
  }
  .order-xs2{
    order: 2;
  }
  .order-xs3{
    order: 3;
  }
  .order-xs4{
    order: 4;
    margin-bottom: 16px;
  }
  .navbar{
    height: auto;
  }
}
</style>
